import type { ReactNode } from "react";

import { HaNResultListEmpty } from "./components/HaNResultListEmpty";
import { HaNResultListError } from "./components/HaNResultListError";
import { HaNResultListHeader } from "./components/HaNResultListHeader";
import { HaNResultListItem } from "./components/HaNResultListItem";
import { HaNResultListLoading } from "./components/HaNResultListLoading";

type HaNResultListCompound = typeof HaNResultListRoot & {
  Header: typeof HaNResultListHeader;
  Item: typeof HaNResultListItem;
  Empty: typeof HaNResultListEmpty;
  Error: typeof HaNResultListError;
  Loading: typeof HaNResultListLoading;
};

const HaNResultListRoot = ({ children }: { children: ReactNode }) => {
  return <ul className="flex flex-col gap-2 px-3 py-2">{children}</ul>;
};

/**
 * A tab's results in the list: items that show what's hovered and selected, with the list's empty, error and loading
 * states.
 */
export const HaNResultList: HaNResultListCompound = Object.assign(HaNResultListRoot, {
  Header: HaNResultListHeader,
  Item: HaNResultListItem,
  Empty: HaNResultListEmpty,
  Error: HaNResultListError,
  Loading: HaNResultListLoading,
});
